export const FETCH_TASKTYPE_BEGIN = "FETCH_TASKTYPE_BEGIN";
export const FETCH_TASKTYPE_SUCCESS = "FETCH_TASKTYPE_SUCCESS";
export const FETCH_TASKTYPE_FAILURE = "FETCH_TASKTYPE_FAILURE";


export const FETCH_TASKS_BEGIN = "FETCH_TASKS_BEGIN";
export const FETCH_TASKS_SUCCESS = "FETCH_TASKS_SUCCESS";
export const FETCH_TASKS_FAILURE = "FETCH_TASKS_FAILURE";

export const FETCH_TASKDETAILS_BEGIN = "FETCH_TASKDETAILS_BEGIN";
export const FETCH_TASKDETAILS_SUCCESS = "FETCH_TASKDETAILS_SUCCESS";
export const FETCH_TASKDETAILS_FAILURE = "FETCH_TASKDETAILS_FAILURE";

export const FETCH_TASKASSIGNEE_BEGIN = "FETCH_TASKASSIGNEE_BEGIN";
export const FETCH_TASKASSIGNEE_SUCCESS = "FETCH_TASKASSIGNEE_SUCCESS";
export const FETCH_TASKASSIGNEE_FAILURE = "FETCH_TASKASSIGNEE_FAILURE";

export const FETCH_TASKDOCUMENTS_BEGIN = "FETCH_TASKDOCUMENTS_BEGIN";
export const FETCH_TASKDOCUMENTS_SUCCESS = "FETCH_TASKDOCUMENTS_SUCCESS";
export const FETCH_TASKDOCUMENTS_FAILURE = "FETCH_TASKDOCUMENTS_FAILURE";

export const FETCH_TASKSETTINGVIEW_BEGIN = "FETCH_TASKSETTINGVIEW_BEGIN";
export const FETCH_TASKSETTINGVIEW_SUCCESS = "FETCH_TASKSETTINGVIEW_SUCCESS";
export const FETCH_TASKSETTINGVIEW_FAILURE = "FETCH_TASKSETTINGVIEW_FAILURE";

export const FETCH_TASKVIEW_BEGIN = "FETCH_TASKVIEW_BEGIN";
export const FETCH_TASKVIEW_SUCCESS = "FETCH_TASKVIEW_SUCCESS";
export const FETCH_TASKVIEW_FAILURE = "FETCH_TASKVIEW_FAILURE";

export const FETCH_TASKVIEWCOLUMN_BEGIN = "FETCH_TASKVIEWCOLUMN_BEGIN";
export const FETCH_TASKVIEWCOLUMN_SUCCESS = "FETCH_TASKVIEWCOLUMN_SUCCESS";
export const FETCH_TASKVIEWCOLUMN_FAILURE = "FETCH_TASKVIEWCOLUMN_FAILURE";

export const FETCH_TASKVIEWCOLUMNBYVIEWID_BEGIN = "FETCH_TASKVIEWCOLUMNBYVIEWID_BEGIN";
export const FETCH_TASKVIEWCOLUMNBYVIEWID_SUCCESS = "FETCH_TASKVIEWCOLUMNBYVIEWID_SUCCESS";
export const FETCH_TASKVIEWCOLUMNBYVIEWID_FAILURE = "FETCH_TASKVIEWCOLUMNBYVIEWID_FAILURE";
